import { Record, Union } from "../fable_modules/fable-library-js.4.19.3/Types.js";
import { Bounds_$reflection } from "./Common/CommonBindings.js";
import { bool_type, float64_type, string_type, class_type, record_type, option_type, int32_type, union_type } from "../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { Shared_UiDataFile_$reflection } from "./VisualizationShared.js";
import { ExtractedData_$reflection } from "./Meshes/MeshExtraction.js";
import { LoadingStatus_$reflection, ImageData_$reflection } from "./Common/CommonTypes.js";
import { ModelVisualizationTemp__get_hasModifiedSegmentations, ModelVisualizationTemp_$reflection, CustomReportData_$reflection, OutboundMsg_$reflection as OutboundMsg_$reflection_1, InboundMsg_$reflection as InboundMsg_$reflection_1, LocalMsg_$reflection as LocalMsg_$reflection_1 } from "./VisualizationTemp/VisualizationTempTypes.js";
import { Msg$3_$reflection } from "../Common/InboundOutbound.js";
import { ModelStentPlanning__get_hasUnsavedChanges, ModelStentPlanning_$reflection, CustomStentReportData_$reflection, OutboundMsg_$reflection as OutboundMsg_$reflection_2, InboundMsg_$reflection as InboundMsg_$reflection_2, LocalMsg_$reflection as LocalMsg_$reflection_2 } from "./StentPlanning/StentPlanningTypes.js";
import { S3Context_$reflection } from "../Common/AwsCommon.js";
import { StudyViewModel_$reflection } from "../RAWMap.Models/View/Study.js";
import { CustomReportStatus_$reflection } from "../RAWMap.Models/View/CustomReport.js";
import { UserData_$reflection, UserRole_$reflection } from "../RAWMap.Models/Security.js";
import { Security_UserInfo$2_$reflection } from "../fable_modules/Webbler.Models.1.6.0/Api.fs.js";
import { InstitutionClinicalDesignation_$reflection } from "../RAWMap.Models/View/Institution.js";

export class InteractionMsg extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["ViewportResized"];
    }
}

export function InteractionMsg_$reflection() {
    return union_type("Client.Visualization.Types.InteractionMsg", [], InteractionMsg, () => [[["Item", Bounds_$reflection()]]]);
}

export class SliderValue extends Record {
    constructor(sliderValue) {
        super();
        this.sliderValue = sliderValue;
    }
}

export function SliderValue_$reflection() {
    return record_type("Client.Visualization.Types.SliderValue", [], SliderValue, () => [["sliderValue", option_type(int32_type)]]);
}

export function SliderValue_get_sliderValue_() {
    return [(m) => m.sliderValue, (v) => ((m_1) => (new SliderValue(v)))];
}

export class LocalMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ExnErrorMsg", "StartVisualization", "FetchData", "ZipDataFetched", "ExtractZipData", "ExtractedZipData", "ExtractZipDataFailure", "ProcessExtractedData", "ImagingFilesExtracted", "VisualizationTempMessage", "StentPlanningMessage", "ForceVisualizationReady", "SetTimeoutId", "ClearTimeout"];
    }
}

export function LocalMsg_$reflection() {
    return union_type("Client.Visualization.Types.LocalMsg", [], LocalMsg, () => [[["Item", class_type("System.Exception")]], [], [["url", string_type]], [["Item", Shared_UiDataFile_$reflection()]], [["Item", Shared_UiDataFile_$reflection()]], [["Item", ExtractedData_$reflection()]], [["Item", class_type("System.Exception")]], [["Item", ExtractedData_$reflection()]], [["Item", ImageData_$reflection()]], [["Item", Msg$3_$reflection(LocalMsg_$reflection_1(), InboundMsg_$reflection_1(), OutboundMsg_$reflection_1())]], [["Item", Msg$3_$reflection(LocalMsg_$reflection_2(), InboundMsg_$reflection_2(), OutboundMsg_$reflection_2())]], [], [["timeoutId", float64_type]], []]);
}

export class InboundMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["GotCredentials", "LaunchVisualization", "UpdateActiveStudy", "ForceSave"];
    }
}

export function InboundMsg_$reflection() {
    return union_type("Client.Visualization.Types.InboundMsg", [], InboundMsg, () => [[["Item1", class_type("Fable.Import.Aws.Credentials.Credentials")], ["Item2", S3Context_$reflection()]], [], [["Item", StudyViewModel_$reflection()]], []]);
}

export class OutboundMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["BackToStudy", "CreateCustomReport", "CreateCustomStentReport", "UpdateCustomReportStatus"];
    }
}

export function OutboundMsg_$reflection() {
    return union_type("Client.Visualization.Types.OutboundMsg", [], OutboundMsg, () => [[], [["Item1", StudyViewModel_$reflection()], ["Item2", CustomReportData_$reflection()]], [["Item1", StudyViewModel_$reflection()], ["Item2", CustomStentReportData_$reflection()]], [["Item", CustomReportStatus_$reflection()]]]);
}

export class Subcomponent extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Notes", "Calipers", "CenterlineMeasurement"];
    }
}

export function Subcomponent_$reflection() {
    return union_type("Client.Visualization.Types.Subcomponent", [], Subcomponent, () => [[], [], []]);
}

export class VisualizationSubcomponentModel extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["VisualizationTemp", "StentPlanning"];
    }
}

export function VisualizationSubcomponentModel_$reflection() {
    return union_type("Client.Visualization.Types.VisualizationSubcomponentModel", [], VisualizationSubcomponentModel, () => [[["Item", ModelVisualizationTemp_$reflection()]], [["Item", ModelStentPlanning_$reflection()]]]);
}

export function VisualizationSubcomponentModel__get_hasUnsavedChanges(this$) {
    if (this$.tag === 1) {
        const model_1 = this$.fields[0];
        if (ModelStentPlanning__get_hasUnsavedChanges(model_1)) {
            return true;
        }
        else {
            return model_1.CanCreateRevision;
        }
    }
    else {
        return ModelVisualizationTemp__get_hasModifiedSegmentations(this$.fields[0]);
    }
}

export class ModelVisualization extends Record {
    constructor(MaybeCurrentUser, PatientInstitutionDesignation, VisualizationDataFile, LoadingStatus, ImageData, S3Context, SelectedStudy, SelectedPatientId, CurrentStudyAnalysisPipelineVersion, MaybePrevStudyAnalysisPipelineVersion, VisualizationSubcomponentModel, ViewportReadyStatusMap, MaybeTimeoutId) {
        super();
        this.MaybeCurrentUser = MaybeCurrentUser;
        this.PatientInstitutionDesignation = PatientInstitutionDesignation;
        this.VisualizationDataFile = VisualizationDataFile;
        this.LoadingStatus = LoadingStatus;
        this.ImageData = ImageData;
        this.S3Context = S3Context;
        this.SelectedStudy = SelectedStudy;
        this.SelectedPatientId = SelectedPatientId;
        this.CurrentStudyAnalysisPipelineVersion = CurrentStudyAnalysisPipelineVersion;
        this.MaybePrevStudyAnalysisPipelineVersion = MaybePrevStudyAnalysisPipelineVersion;
        this.VisualizationSubcomponentModel = VisualizationSubcomponentModel;
        this.ViewportReadyStatusMap = ViewportReadyStatusMap;
        this.MaybeTimeoutId = MaybeTimeoutId;
    }
}

export function ModelVisualization_$reflection() {
    return record_type("Client.Visualization.Types.ModelVisualization", [], ModelVisualization, () => [["MaybeCurrentUser", option_type(Security_UserInfo$2_$reflection(UserRole_$reflection(), UserData_$reflection()))], ["PatientInstitutionDesignation", InstitutionClinicalDesignation_$reflection()], ["VisualizationDataFile", string_type], ["LoadingStatus", LoadingStatus_$reflection()], ["ImageData", option_type(ImageData_$reflection())], ["S3Context", S3Context_$reflection()], ["SelectedStudy", StudyViewModel_$reflection()], ["SelectedPatientId", class_type("System.Guid")], ["CurrentStudyAnalysisPipelineVersion", float64_type], ["MaybePrevStudyAnalysisPipelineVersion", option_type(float64_type)], ["VisualizationSubcomponentModel", VisualizationSubcomponentModel_$reflection()], ["ViewportReadyStatusMap", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, bool_type])], ["MaybeTimeoutId", option_type(float64_type)]]);
}

